import { ILoaiChungChiDanhSachMonActionTypes } from "../../action-types/chuong-trinh-dao-tao/ILoaiChungChiDanhSachMonActions";
import { ILoaiChungChiDanhSachMonReducer } from "../../reducer-model/chuong-trinh-dao-tao/ILoaiChungChiDanhSachMonReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: ILoaiChungChiDanhSachMonReducer = {
    status: eReducerStatusBase.is_not_initialization,
    loaiChungChiDanhSachMons: [],
    isShowAddMonHocModal: false,
}

export const loaiChungChiDanhSachMonReducer = (state: ILoaiChungChiDanhSachMonReducer = initialState, action: ILoaiChungChiDanhSachMonActionTypes): ILoaiChungChiDanhSachMonReducer => {
    switch (action.type) {
        case "LOAI_CHUNG_CHI_DANH_SACH_MON_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "LOAI_CHUNG_CHI_DANH_SACH_MON_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                loaiChungChiDanhSachMons: action.payload,
            };
        case "LOAI_CHUNG_CHI_DANH_SACH_MON_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "LOAI_CHUNG_CHI_DANH_SACH_MON_SYS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "LOAI_CHUNG_CHI_DANH_SACH_MON_SYS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "LOAI_CHUNG_CHI_DANH_SACH_MON_SYS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}